module.exports = __webpack_public_path__ + "img/hy4.88c86ae0.png";